var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJournalWithNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.5C5 14.2239 5.22386 14 5.5 14H7.5C7.77614 14 8 14.2239 8 14.5C8 14.7761 7.77614 15 7.5 15H5.5C5.22386 15 5 14.7761 5 14.5Z",
    fill: "#6F6F6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12.5C5 12.2239 5.22386 12 5.5 12H10.5C10.7761 12 11 12.2239 11 12.5C11 12.7761 10.7761 13 10.5 13H5.5C5.22386 13 5 12.7761 5 12.5Z",
    fill: "#6F6F6F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.5C5 10.2239 5.22386 10 5.5 10H10.5C10.7761 10 11 10.2239 11 10.5C11 10.7761 10.7761 11 10.5 11H5.5C5.22386 11 5 10.7761 5 10.5Z",
    fill: "#6F6F6F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.5C5 8.22386 5.22386 8 5.5 8H10.5C10.7761 8 11 8.22386 11 8.5C11 8.77614 10.7761 9 10.5 9H5.5C5.22386 9 5 8.77614 5 8.5Z",
    fill: "#6F6F6F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 4H13C14.1046 4 15 4.89543 15 6V18C15 19.1046 14.1046 20 13 20H3C1.89543 20 1 19.1046 1 18V17H2V18C2 18.5523 2.44772 19 3 19H13C13.5523 19 14 18.5523 14 18V6C14 5.44772 13.5523 5 13 5H3C2.44772 5 2 5.44772 2 6V7H1V6C1 4.89543 1.89543 4 3 4Z",
    fill: "#6F6F6F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9V8.5C1 8.22386 1.22386 8 1.5 8C1.77614 8 2 8.22386 2 8.5V9H2.5C2.77614 9 3 9.22386 3 9.5C3 9.77614 2.77614 10 2.5 10H0.5C0.223858 10 0 9.77614 0 9.5C0 9.22386 0.223858 9 0.5 9H1Z",
    fill: "#6F6F6F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12V11.5C1 11.2239 1.22386 11 1.5 11C1.77614 11 2 11.2239 2 11.5V12H2.5C2.77614 12 3 12.2239 3 12.5C3 12.7761 2.77614 13 2.5 13H0.5C0.223858 13 0 12.7761 0 12.5C0 12.2239 0.223858 12 0.5 12H1Z",
    fill: "#6F6F6F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1 15V14.5C1 14.2239 1.22386 14 1.5 14C1.77614 14 2 14.2239 2 14.5V15H2.5C2.77614 15 3 15.2239 3 15.5C3 15.7761 2.77614 16 2.5 16H0.5C0.223858 16 0 15.7761 0 15.5C0 15.2239 0.223858 15 0.5 15H1Z",
    fill: "#6F6F6F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 4.5,
    r: 4.5,
    fill: "#1D1D1D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8C14.9832 8 15.375 7.60825 15.375 7.125H13.625C13.625 7.60825 14.0168 8 14.5 8Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9354 1.48083C14.9368 1.46657 14.9375 1.45212 14.9375 1.4375C14.9375 1.19588 14.7416 1 14.5 1C14.2584 1 14.0625 1.19588 14.0625 1.4375C14.0625 1.45212 14.0632 1.46658 14.0646 1.48083C13.0651 1.6827 12.3125 2.56596 12.3125 3.625C12.3125 4.1052 12.0938 6.25 11.4375 6.6875H17.5625C16.9062 6.25 16.6875 4.1052 16.6875 3.625C16.6875 2.56595 15.9349 1.68268 14.9354 1.48083Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournalWithNotification);
export default __webpack_public_path__ + "static/media/journalWithNotification.a47881ed.svg";
export { ForwardRef as ReactComponent };